export type DeltaDirection = 'down' | 'flat' | 'up'

// Which way a delta moved, read off the string the API sends.
//
// The colour and the arrow follow the NUMBER, not whether the move is good for
// the brand: up is green with an up arrow, down is red with a down arrow,
// everywhere the report shows a delta. The report used to colour by meaning —
// negative mentions falling counted as good news, so it went green — while the
// arrow was hardcoded upwards, so a card could read "-86.7%" in green under an
// arrow pointing up.
//
// The API's own formats are the only cases here: percentages come back as
// '+34.5%' / '-77.6%' / '0%' / 'New', the sentiment score as '+7pts' / '-1pts',
// and the source count as '+3 sources' / '-1 source' / '0 sources'.
export const deltaDirection = (delta: string): DeltaDirection => {
  const value = delta.trim()

  if (value.startsWith('-')) {
    return 'down'
  }

  // A period that had nothing to compare against reads as 'New' — a rise from
  // zero, so it points up like any other increase.
  if (value.startsWith('+') || value.toLowerCase() === 'new') {
    return 'up'
  }

  // What is left is a zero: '0%', '0 sources'. Nothing moved, so neither an
  // arrow nor a colour would be telling the truth.
  return 'flat'
}
